// extracted by mini-css-extract-plugin
export default {"logoMobile":"Logo_logoMobile__+ZdF-"};